var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"page d-flex align-content-start",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.list),function(item){return _c('Label',{key:item.id,attrs:{"orderItem":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }